module.exports = __webpack_public_path__ + "img/sand-clock.d4e2f181.svg";